import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { AfterContentChecked, Component, ElementRef, EventEmitter,
         HostListener, Inject, Input, Output, Renderer2, ViewChild
       } from '@angular/core';

import { Utils } from 'core/utils';
import { ColorPalette, ColorPaletteService } from './color-palette.service';

interface PhantomPalette {
  baseColors: Array<any>;
  additionalColors: Array<any>;
}

@Component({
    selector: 'color-chooser',
    templateUrl: './color-chooser.component.html',
    styleUrls: ['./color-chooser.component.scss'],
    standalone: false
})
export class ColorChooserComponent implements AfterContentChecked
{
  private static readonly ARROW_SIZE: number = 10; /* px */

  @ViewChild('root') private root: CdkOverlayOrigin;

  @Output() public currentColorChange: EventEmitter<string> =
      new EventEmitter();

  @Input() public currentColor: string = '#666';
  @Input() public palette: Array<string> = [];

  public colors: ColorPalette = {
    baseColors: [],
    additionalColors: [],
  };

  public phantoms: PhantomPalette = {
    baseColors: [],
    additionalColors: [],
  };
  private previousWrapperWidth: number = 0;

  public additionalColors: Array<string> = [];
  public showPalette: boolean = false;

  public paletteHeight: number = 0;
  public paletteWidth: number = 0;
  public arrowLeft: number = 0;

  constructor(
      private element: ElementRef,
      @Inject(Renderer2) private renderer: Renderer2,
      @Inject(ColorPaletteService)
          public colorPaletteService: ColorPaletteService)
  { }

  public ngAfterContentChecked(): void
  {
    if (this.palette.length > 0) {
      this.colors.baseColors = this.palette;
    }
    else {
      this.colors.baseColors = this.colorPaletteService.colorPalette.baseColors;
      this.colors.additionalColors =
          this.colorPaletteService.colorPalette.additionalColors;
    }

    if (this.showPalette) {
      this.updatePhantomColors();
    }
  }

  public onOverlayAttach(): void
  {
    const wrapper = document.querySelector('.colors-wrapper') as HTMLElement;
    if (wrapper) {
      this.renderer.setProperty(
         wrapper,
         'style',
         `--checkmark-url: url(${Utils.url('./assets/img/checkmark.svg')})`,
      );
    }
  }

  public setColor(color: string): void
  {
    this.currentColor = color;
    this.showPalette = false;
    this.currentColorChange.emit(color);
  }

  public adaptPaletteHeight(): void
  {
    if (!this.showPalette) {
      return;
    }

    const rootNode = this.element.nativeElement.getRootNode();
    const editor = rootNode.querySelector('.editor');
    const toolbar = <any>editor.querySelector('.toolbar');
    const root = this.root.elementRef.nativeElement as HTMLElement;
    const availableWidth = toolbar.offsetWidth;

    this.paletteWidth = availableWidth;
    this.paletteHeight = toolbar.offsetTop + root.offsetTop;

    this.arrowLeft =
      root.offsetLeft + root.offsetWidth / 2 - ColorChooserComponent.ARROW_SIZE;
  }

  private updatePhantomColors(): void
  {
    // Adjusting by -10 to match nearly the original wrapper width
    // Reading the wrapper's clientWidth as before is not reliable
    // because of ShadowDom and CDK overlay, it isn't correct initialized
    // at this point.. Thanks to Safari for this weird workarounds.
    const wrapperWidth = this.paletteWidth - 10;

    if (wrapperWidth < 1 || wrapperWidth === this.previousWrapperWidth) {
      return;
    }

    const getPhantomCount = (colors: Array<any>) => {
      const itemWidth = 28 + 10 + 2; // width + 2 * margin + 2 * border
      const itemsPerRow = Math.floor(wrapperWidth / itemWidth);
      return Array(itemsPerRow - (colors.length % itemsPerRow))
        .map(_ => undefined);
    };

    this.phantoms = {
      additionalColors: getPhantomCount(this.colors.additionalColors),
      baseColors: getPhantomCount(this.colors.baseColors)
    };

    this.previousWrapperWidth = wrapperWidth;
  }
}
